/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanCountDown from 'vant/es/count-down'
import 'vant/es/count-down/style/less'
import VanLoading from 'vant/es/loading'
import 'vant/es/loading/style/less'
import VanPasswordInput from 'vant/es/password-input'
import 'vant/es/password-input/style/less'


import { render, staticRenderFns } from "./captcha-popup.vue.js?vue&type=template&id=045a1c0e!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./captcha-popup.vue?vue&type=template&id=045a1c0e"
import script from "./captcha-popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./captcha-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./captcha-popup.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./captcha-popup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./captcha-popup.vue.postcss?vue&type=style&index=0&id=045a1c0e&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./captcha-popup.vue?vue&type=style&index=0&id=045a1c0e&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanCountDown,VanLoading,VanPasswordInput})
